import {
    CANCEL_FILE_UPLOAD,
    COMPLETE_FILE_UPLOAD,
    ERROR_FILE_UPLOAD,
    INIT_FILE_UPLOADS,
    REMOVE_ALL_FILE_UPLOADS,
    REMOVE_FILE_UPLOAD,
    UPDATE_FILE_UPLOAD,
} from '../actions/fileUploads';

export const FileUploadState = {
    INIT: 'INIT',
    IN_PROGRESS: 'IN_PROGRESS',
    CANCELLED: 'CANCELLED',
    COMPLETED: 'COMPLETED',
    ERROR: 'ERROR',
};

const fileUploads = (state = [], action = undefined) => {
    switch (action.type) {
        case INIT_FILE_UPLOADS:
            return action.payload.map((fileName) => ({
                fileName,
                progress: 0,
                state: FileUploadState.INIT,
                errorMessageCode: null,
                errorMessageParams: null,
                responseData: null,
            }));
        case REMOVE_ALL_FILE_UPLOADS:
            return [];
        case REMOVE_FILE_UPLOAD:
            return state.filter((fileProgress) => fileProgress.fileName !== action.payload);
        case CANCEL_FILE_UPLOAD:
            return state.map((fileProgress) => {
                const result = fileProgress;
                if (result.fileName === action.payload) {
                    result.state = FileUploadState.CANCELLED;
                    result.responseData = null;
                }
                return result;
            });
        case COMPLETE_FILE_UPLOAD:
            return state.map((fileProgress) => {
                const result = fileProgress;
                if (result.fileName === action.payload.fileName) {
                    result.state = FileUploadState.COMPLETED;
                    result.responseData = action.payload.responseData;
                    result.responseFileName = action.payload.responseFileName;
                }
                return result;
            });
        case ERROR_FILE_UPLOAD:
            return state.map((fileProgress) => {
                const result = fileProgress;
                if (result.fileName === action.payload.fileName) {
                    result.state = FileUploadState.ERROR;
                    result.errorMessageCode = action.payload.errorMessageCode;
                    result.errorMessageParams = action.payload.errorMessageParams;
                    result.responseData = null;
                }
                return result;
            });
        case UPDATE_FILE_UPLOAD:
            return state.map((fileProgress) => {
                const result = fileProgress;
                if (result.fileName === action.payload.fileName) {
                    result.progress = action.payload.progress;
                    result.state = FileUploadState.IN_PROGRESS;
                    result.errorMessageCode = null;
                    result.responseData = null;
                }
                return result;
            });
        default:
            return state;
    }
};

export default fileUploads;
